import React from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid } from 'recharts';

// Mock data reflecting the specific timestamps and values in the image
const data = [
  { time: '06:00', chillers: -2, refrigerators: -6, freezers: -24 },
  { time: '07:00', chillers: 0, refrigerators: -5, freezers: -25 },
  { time: '08:00', chillers: -1, refrigerators: -6, freezers: -24 },
  { time: '09:00', chillers: -1, refrigerators: -5, freezers: -24 },
  { time: '10:00', chillers: -1, refrigerators: -6, freezers: -24 },
  { time: '11:00', chillers: -2, refrigerators: -6, freezers: -24 },
  { time: '12:00', chillers: 0, refrigerators: -5, freezers: -24 },
  { time: '13:00', chillers: -2, refrigerators: -6, freezers: -24 },
  { time: '14:00', chillers: -1, refrigerators: -6, freezers: -24 },
  { time: '15:00', chillers: 0, refrigerators: -5, freezers: -24 },
  { time: '16:00', chillers: -1, refrigerators: -6, freezers: -25 },
  { time: '17:00', chillers: -1, refrigerators: -5, freezers: -24 },
  { time: '18:00', chillers: 0, refrigerators: -5, freezers: -25 },
  { time: '19:00', chillers: -1, refrigerators: -5, freezers: -24 },
  { time: '20:00', chillers: -1, refrigerators: -6, freezers: -25 },
  { time: '21:00', chillers: 0, refrigerators: -5, freezers: -24 },
  { time: '22:00', chillers: -1, refrigerators: -6, freezers: -25 },
  { time: '23:00', chillers: 0, refrigerators: -5, freezers: -24 },
  { time: 'Now', chillers: -1, refrigerators: -6, freezers: -25 },
];

export default function TemperatureTrend() {
  return (
    <div className="w-full bg-[#FAF9F6] border border-gray-100 rounded-xl p-6 font-sans shadow-sm select-none">
      
      {/* Title Header */}
      <h2 className="text-xl font-bold text-gray-900 tracking-tight mb-6">
        Temperature Trend (Live)
      </h2>

      {/* Custom Centered Legend */}
      <div className="flex justify-center items-center gap-8 mb-8 text-sm font-medium text-gray-600">
        <div className="flex items-center gap-3">
          <span className="w-5 h-0.5 bg-[#0052FF] rounded-full inline-block"></span>
          <span>Chillers</span>
        </div>
        <div className="flex items-center gap-3">
          <span className="w-5 h-0.5 bg-[#00A854] rounded-full inline-block"></span>
          <span>Refrigerators</span>
        </div>
        <div className="flex items-center gap-3">
          <span className="w-5 h-0.5 bg-[#722ED1] rounded-full inline-block"></span>
          <span>Freezers</span>
        </div>
      </div>

      {/* Main Chart Area */}
      <div className="w-full h-64 pr-4">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
            {/* Soft, invisible grid style to match clean look */}
            <CartesianGrid vertical={false} stroke="#E5E7EB" strokeWidth={0.5} opacity={0.3} />
            
            <XAxis 
              dataKey="time" 
              axisLine={false}
              tickLine={false}
              tick={{ fill: '#4B5563', fontSize: 12, fontWeight: 500 }}
              dy={15}
              // Limits labels to show clean intervals mirroring the reference image
              ticks={['06:00', '09:00', '12:00', '15:00', '18:00', '21:00', 'Now']}
            />
            
            <YAxis 
              domain={[-35, 15]}
              ticks={[10, 0, -10, -20, -30]}
              axisLine={false}
              tickLine={false}
              tickFormatter={(value) => `${value}°C`}
              tick={{ fill: '#4B5563', fontSize: 12, fontWeight: 500 }}
              dx={-10}
            />

            {/* Chiller Line (Blue) */}
            <Line 
              type="monotone" 
              dataKey="chillers" 
              stroke="#0052FF" 
              strokeWidth={2} 
              dot={false}
              activeDot={{ r: 4 }}
            />

            {/* Refrigerator Line (Green) */}
            <Line 
              type="monotone" 
              dataKey="refrigerators" 
              stroke="#00A854" 
              strokeWidth={2} 
              dot={false}
              activeDot={{ r: 4 }}
            />

            {/* Freezer Line (Purple) */}
            <Line 
              type="monotone" 
              dataKey="freezers" 
              stroke="#722ED1" 
              strokeWidth={2} 
              dot={false}
              activeDot={{ r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Footer Metrics Indicator */}
      <div className="flex justify-between items-center mt-6 text-sm font-medium text-gray-500">
        <div className="flex items-center gap-2">
          <span className="w-2.5 h-2.5 bg-[#00A854] rounded-full animate-pulse"></span>
          <span className="text-gray-700">Live (Today)</span>
        </div>
        <div className="text-gray-400 font-normal">
          All temperatures in °C
        </div>
      </div>

    </div>
  );
}
